import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const organizationApi = createApi({
  reducerPath: 'organizationApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Organization', 'Members'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getOrgName: builder.query({
      query: () => ({
        url: '/license/organization/name',
      }),
      transformResponse: (response) => response.result.work_place_name, // Extracts the organization name from the API response
      providesTags: ['Organization'], // Tells RTK Query this query provides 'Organization' data and to refetch when invalidated
    }),
    updateOrgName: builder.mutation({
      query: (name) => ({
        url: '/license/organization/name',
        method: 'POST',
        data: { newOrganizationName: name },
      }),
      invalidatesTags: ['Organization'], // Tells RTK Query to invalidate 'Organization' data and refetch when this mutation is successful
    }),
    getWorkplaceMembers: builder.query({
      query: (accessLevels) => ({
        url: '/users/members',
        method: 'GET',
        params: {
          levels: Array.isArray(accessLevels) ? accessLevels.join(',') : accessLevels,
        },
      }),
      transformResponse: (response) => response.result, // Extracts the 'result' array from the API response
      providesTags: ['Members'], // Tells RTK Query this query provides 'Members' data and to refetch when invalidated
    }),
  }),
});

export const { useGetOrgNameQuery, useUpdateOrgNameMutation, useGetWorkplaceMembersQuery } = organizationApi;
